import { useParams, Link, Navigate } from "react-router-dom";
import PageShell from "@/components/site/PageShell";
import SEO from "@/components/site/SEO";
import JsonLd, { buildBreadcrumbs } from "@/components/site/JsonLd";
import { blogPosts } from "@/data/blogPosts";
import { CheckCircle2, ArrowLeft } from "lucide-react";
import { whatsappHref } from "@/lib/format";

export default function BlogPost() {
  const { slug } = useParams();
  const post = blogPosts.find((p) => p.slug === slug);

  if (!post) return <Navigate to="/blog" replace />;

  const url = `https://www.transporteenvanesybuses.com/blog/${post.slug}`;

  return (
    <PageShell testid={`page-blog-${post.slug}`}>
      <SEO title={post.metaTitle} description={post.metaDescription} />
      <JsonLd
        id="breadcrumb-jsonld"
        data={buildBreadcrumbs([
          { name: "Inicio", url: "https://www.transporteenvanesybuses.com/" },
          { name: "Blog", url: "https://www.transporteenvanesybuses.com/blog" },
          { name: post.title, url },
        ])}
      />
      <JsonLd
        id="article-jsonld"
        data={{
          "@context": "https://schema.org",
          "@type": "Article",
          "headline": post.title,
          "description": post.metaDescription,
          "datePublished": post.date,
          "dateModified": post.date,
          "author": { "@id": "https://www.transporteenvanesybuses.com/#organization" },
          "publisher": { "@id": "https://www.transporteenvanesybuses.com/#organization" },
          "mainEntityOfPage": url,
        }}
      />

      <section className="relative pt-16 md:pt-24 pb-10">
        <div className="orb-gold w-[460px] h-[460px] right-[-140px] top-[80px] opacity-60" />
        <div className="max-w-3xl mx-auto px-5 md:px-8 relative">
          <Link to="/blog" className="text-sm text-[#E8C87A] inline-flex items-center gap-1.5 mb-6 hover:gap-2.5" style={{ transitionProperty: "gap", transitionDuration: "200ms" }}>
            <ArrowLeft size={14} /> Volver al blog
          </Link>
          <div className="text-[#E8C87A] text-xs uppercase tracking-[0.3em] mb-4">
            {new Date(post.date).toLocaleDateString("es-CO", { day: "numeric", month: "long", year: "numeric" })}
          </div>
          <h1 className="font-display text-3xl md:text-5xl leading-[1.1] text-[#F5EFE0]">{post.title}</h1>
        </div>
      </section>

      <section className="pb-16 md:pb-24">
        <div className="max-w-3xl mx-auto px-5 md:px-8 space-y-10">
          {post.sections.map((s, i) => (
            <div key={i}>
              <h2 className="font-display text-2xl md:text-3xl text-[#F5EFE0] mb-4">{s.heading}</h2>
              {s.paragraphs?.map((p, j) => (
                <p key={j} className="text-[#F5EFE0]/70 leading-relaxed mb-3">{p}</p>
              ))}
              {s.list && (
                <ul className="space-y-2 mt-3">
                  {s.list.map((item, j) => (
                    <li key={j} className="flex items-start gap-2 text-sm text-[#F5EFE0]/80">
                      <CheckCircle2 size={16} className="text-[#E8C87A] mt-0.5 shrink-0" /> {item}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}

          <div className="card-lux p-6 md:p-8 text-center">
            <div className="font-display text-xl md:text-2xl text-[#F5EFE0] mb-4">
              ¿Listo para cotizar tu transporte?
            </div>
            <div className="flex flex-wrap gap-3 justify-center">
              <Link to="/cotizar" className="btn-gold px-6 py-3 rounded-full text-sm">Cotizar ahora</Link>
              <a href={whatsappHref("573123616674", `Hola, leí el artículo "${post.title}" y quiero más información`)} target="_blank" rel="noreferrer" className="btn-ghost-gold px-6 py-3 rounded-full text-sm">
                Escribir por WhatsApp
              </a>
            </div>
          </div>
        </div>
      </section>
    </PageShell>
  );
}
